/**
 * DueDatePill — inline calendar-icon + date.
 *
 * Mockup: `<span class="${dueCls}"><svg…>icon</svg>{date}</span>`
 * Class is empty / `.due-soon` / `.overdue` based on date proximity.
 * Used inside .kc-meta (kanban card foot), task list cells, task detail meta.
 */

import { Icon } from "./Icon";
import { classifyDue, formatDateShort, parseDateLocal } from "@/lib/format";

interface DueDatePillProps {
  /** ISO date string or Date */
  due: string | Date;
}

export function DueDatePill({ due }: DueDatePillProps) {
  const date = parseDateLocal(due);
  if (!date) return null;
  // The kanban card CSS targets `.due-soon` / `.overdue` — map the
  // canonical "soon" verdict to the CSS class the design expects.
  const c = classifyDue(date);
  const cls = c === "soon" ? "due-soon" : c;
  return (
    <span
      className={cls}
      style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
    >
      <Icon name="clock" size={12} />
      {formatDateShort(date)}
    </span>
  );
}
